/**
 * The local event queue (M3.6b). One press is one event; the endpoint that
 * will drain it is M5.3's, and until then the rows wait in this browser.
 *
 * Two tables, because the Spec measures two things: an action on an active
 * card is a `ProductAction`, and a Probably done? answer is a
 * `HistoryConfirmation` — "valuable product evidence, but measured separately
 * from an action on an active ledger item". Nothing here can carry content:
 * both record types are ids, a verb from a closed set, a section and a time.
 */
import type { HistoryConfirmation, ProductAction } from '@cordelia/core'
import { db } from '../store/db.js'

/** One action on an active card. */
export async function recordAction(action: ProductAction): Promise<void> {
  await db().product_actions.add(action)
}

/** One Probably done? answer. Never counted as an action. */
export async function recordConfirmation(confirmation: HistoryConfirmation): Promise<void> {
  await db().history_confirmations.add(confirmation)
}

export async function listActions(): Promise<readonly ProductAction[]> {
  return db().product_actions.orderBy('seq').toArray()
}

export async function listConfirmations(): Promise<readonly HistoryConfirmation[]> {
  return db().history_confirmations.orderBy('seq').toArray()
}
